import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'bg',
  months: [
    'януари',
    'февруари',
    'март',
    'април',
    'май',
    'юни',
    'юли',
    'август',
    'септември',
    'октомври',
    'ноември',
    'декември',
  ],
  monthsShort: ['яну', 'фев', 'март', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'],
  weekdays: ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'],
  weekdaysMin: ['н', 'п', 'в', 'с', 'ч', 'п', 'с'],
  weekdaysShort: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  formats: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    lt: 'H:mm',
    lts: 'H:mm:ss',
    L: 'D.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM ',
    LLL: 'D MMMM YYYY H:mm',
    'LLL-Y': 'D MMMM H:mm',
    LLLL: 'dddd, D MMMM YYYY H:mm',
    'LLLL-Y': 'dddd, D MMMM H:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M.',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY H:mm',
    'lll-Y': 'D MMM H:mm',
    llll: 'ddd, D MMM YYYY H:mm',
    'llll-Y': 'ddd, D MMM H:mm',
    'll-Y+w': 'ddd, D.MM',
    'LT+to': 'HH:mm [ч]. ([Гринуич]Z)',
    'LLL+to': 'D MMMM YYYY [г]., HH:mm [ч]. ([Гринуич]Z)',
  },
  past: {
    y: { one: 'преди %s г.', other: 'преди %s г.' },
    M: { one: 'преди %s м.', other: 'преди %s м.' },
    w: { one: 'преди %s седм.', other: 'преди %s седм.' },
    d: { one: 'преди %s ден', other: 'преди %s дни' },
    h: { one: 'преди %s ч', other: 'преди %s ч' },
    m: { one: 'преди %s мин', other: 'преди %s мин' },
    s: { one: 'преди %s сек', other: 'преди %s сек' },
  },
  future: {
    y: { one: 'след %s г.', other: 'след %s г.' },
    M: { one: 'след %s м.', other: 'след %s м.' },
    w: { one: 'след %s седм.', other: 'след %s седм.' },
    d: { one: 'след %s ден', other: 'след %s дни' },
    h: { one: 'след %s ч', other: 'след %s ч' },
    m: { one: 'след %s мин', other: 'след %s мин' },
    s: { one: 'след %s сек', other: 'след %s сек' },
  },
  abbr: {
    y: { one: '%s г.', other: '%s г.' },
    M: { one: '%s мес.', other: '%s мес.' },
    w: { one: '%s сед.', other: '%s сед.' },
    d: { one: '%s ден', other: '%s дни' },
    h: { one: '%s час', other: '%s часа' },
    m: { one: '%s мин.', other: '%s мин.' },
    s: { one: '%s сек.', other: '%s сек.' },
  },
  justNow: 'в момента',
  yesterday: 'вчера',
  today: 'днес',
  tomorrow: 'утре',
  weekStart: 1,
};
const localeName: LocaleName = 'bg';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
